import { render, staticRenderFns } from "./VsmeHealth.vue?vue&type=template&id=b946fa94&scoped=true"
import script from "./VsmeHealth.vue?vue&type=script&lang=js"
export * from "./VsmeHealth.vue?vue&type=script&lang=js"
import style0 from "./VsmeHealth.vue?vue&type=style&index=0&id=b946fa94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b946fa94",
  null
  
)

export default component.exports